import { callAPI } from '../../network/networkConnection';

const BASE_URL = process.env.REACT_APP_APIUrl + 'admin/products';

/** Persist active export job across navigations (server continues processing). */
export const EXPORT_JOB_STORAGE_KEY = 'pe_export_job_id';
/** Persist bulk-subscribe across navigations — server keeps processing same as export jobs. */
export const BULK_SUBSCRIBE_JOB_STORAGE_KEY = 'pe_bulk_subscribe_job_id';

export const ProductExportService = {
  getCount: (filters = {}) => callAPI(
    `${BASE_URL}/export-count`,
    'POST',
    { 'Content-Type': 'application/json' },
    JSON.stringify({ filters })
  ),

  /** Starts DB-backed async export — returns immediately with exportJobId. */
  startExportJob: (filters = {}, exportFieldKeys = null) => {
    const body = exportFieldKeys ? { filters, exportFieldKeys } : { filters };
    return callAPI(
      `${BASE_URL}/export-job`,
      'POST',
      { 'Content-Type': 'application/json' },
      JSON.stringify(body),
    );
  },

  getExportFieldCatalog: () => callAPI(
    `${BASE_URL}/export-field-catalog`,
    'GET',
    { 'Content-Type': 'application/json' },
    null
  ),

  getExportJobStatus: (exportJobId) => callAPI(
    `${BASE_URL}/export-job/${encodeURIComponent(exportJobId)}/status?ts=${encodeURIComponent(Date.now())}`,
    'GET',
    { 'Content-Type': 'application/json' },
    null
  ),

  listExportJobs: (limit = 20, skip = 0, jobKind = 'export') => callAPI(
    `${BASE_URL}/export-jobs?limit=${encodeURIComponent(limit)}&skip=${encodeURIComponent(skip)}&jobKind=${encodeURIComponent(jobKind)}`,
    'GET',
    { 'Content-Type': 'application/json' },
    null
  ),

  startBulkSubscribeJob: (filters = {}, userIds = []) =>
    callAPI(
      `${BASE_URL}/bulk-subscribe-job`,
      'POST',
      { 'Content-Type': 'application/json' },
      JSON.stringify({ filters, userIds }),
    ),

  searchSubscribeTargetUsers: (search = '', limit = 25) =>
    callAPI(
      `${BASE_URL}/subscribe-target-users?search=${encodeURIComponent(search)}&limit=${encodeURIComponent(limit)}`,
      'GET',
      { 'Content-Type': 'application/json' },
      null,
    ),

  /**
   * Stop export only: sets status `cancelled` on the server — the job row is **not** deleted (stays in history).
   * Uses POST …/cancel (not a DB delete).
   */
  cancelExportJob: (exportJobId) => callAPI(
    `${BASE_URL}/export-job/${encodeURIComponent(exportJobId)}/cancel`,
    'POST',
    { 'Content-Type': 'application/json' },
    '{}'
  ),

  getExportJobDownloadUrl: (exportJobId) => `${BASE_URL}/export-job/${encodeURIComponent(exportJobId)}/download`,

  /** Deletes the ZIP from S3 (and/or local) and marks the job finished. */
  removeExportJobFile: (exportJobId) => callAPI(
    `${BASE_URL}/export-job/${encodeURIComponent(exportJobId)}/file`,
    'DELETE',
    { 'Content-Type': 'application/json' },
    null,
  ),

  searchTags: (search = '', limit = 50, offset = 0) => callAPI(
    `${BASE_URL}/export-tags?search=${encodeURIComponent(search)}&limit=${limit}&offset=${offset}`,
    'GET',
    { 'Content-Type': 'application/json' },
    null
  ),

  /* Category mapped by user filter — disabled
  searchMappedUsers: (search = '', limit = 20) => callAPI(
    `${BASE_URL}/export-mapped-users?search=${encodeURIComponent(search)}&limit=${limit}`,
    'GET',
    { 'Content-Type': 'application/json' },
    null
  ),
  */

  searchSkuUploadBatches: (search = '', limit = 15, offset = 0) => callAPI(
    `${BASE_URL}/export-sku-upload-batches?search=${encodeURIComponent(search)}&limit=${encodeURIComponent(limit)}&offset=${encodeURIComponent(offset)}`,
    'GET',
    { 'Content-Type': 'application/json' },
    null
  ),

  getExportUrl: () => `${BASE_URL}/export`,
};

export default ProductExportService;
